import { Component } from '@angular/core';
import { FeaturesEnum } from '../../../feature-flag/enums/feature.enum';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  isActive = false;
  protected readonly FeaturesEnum = FeaturesEnum;

  onBurgerClick() {
    this.isActive = !this.isActive;
  }
}
